module.exports = __webpack_public_path__ + "img/LIGHTING 2 LIME.89afc6c.svg";